import React, { useState } from "react";
import { Form, Input, Button, Icon, Alert } from "antd";
import axios from 'axios';

//axios.defaults.baseURL = "https://localhost:5000/sendmail/";
axios.defaults.baseURL = "https://cloudfunctions.teknomaint.it/sendmail/";
axios.defaults.timeout = 60 * 1000;
axios.defaults.headers.post['Content-Type'] = 'application/json';

const { TextArea } = Input;

const CreateFormContatti = ({ form: { validateFields, getFieldDecorator }, objectForm, type }) => {

    const [state, setState] = useState({
        form: {
            name: null,
            email: null,
            phone: null,
            message: null
        },
        validForm: null,
        loading: false
    });


    const handleSubmit = async (e) => {
        e.preventDefault();
        validateFields((err, values) => {
            if (!err) {

                var val = {
                    section: objectForm,
                    name: values.name,
                    email: values.email,
                    phone: values.phone || null,
                    message: values.message
                }
                setState({
                    ...state,
                    validForm: null,
                    loading: true
                });
                sendMail(val);
            }
        });
    };

    const sendMail = (val) => {

        axios.post('contatti', val).then(function (res) {
            if (res && res.data && res.data.status === 200) {
                setState({
                    ...state,
                    validForm: true,
                    loading: false
                });
            } else {
                setState({
                    ...state,
                    validForm: false,
                    loading: false
                });
            }
        }).catch(function (error) {
            console.log(error);
            setState({
                ...state,
                validForm: false,
                loading: false
            });
        });
    }

    return <Form onSubmit={handleSubmit} className="form-contatti">
        <Form.Item className="text-left">
            <span className={!type ? "color-white" : null}>Nome *</span>
            {getFieldDecorator("name", {
                rules: [
                    { required: true, message: "Nome campo obbligatorio." }
                ],
                initialValue: state.form.name
            })(
                <Input
                    type={'text'}
                    placeholder="Nome"
                />
            )}
        </Form.Item>
        <Form.Item className="text-left">
            <span className={!type ? "color-white" : null}>Email *</span>
            {getFieldDecorator("email", {
                rules: [
                    { required: true, message: "Email campo obbligatorio." }
                ],
                initialValue: state.form.email
            })(
                <Input
                    type={'email'}
                    placeholder="Email"
                />
            )}
        </Form.Item>
        <Form.Item className="text-left">
            <span className={!type ? "color-white" : null}>Telefono</span>
            {getFieldDecorator("phone", {
                rules: [
                    { required: false }
                ],
                initialValue: state.form.phone
            })(
                <Input
                    type={'text'}
                    placeholder="Telefono"
                />
            )}
        </Form.Item>
        <Form.Item className="text-left">
            <span className={!type ? "color-white" : null}>Messaggio *</span>
            {getFieldDecorator("message", {
                rules: [
                    { required: true, message: "Messaggio campo obbligatorio" }
                ],
                initialValue: state.form.message
            })(
                <TextArea rows={5} />
            )}
        </Form.Item>
        {state.validForm === true ? <Alert message="Messaggio inviato con successo." type="success" /> : null}
        {state.validForm === false ? <Alert message="Errore: impossibile inviare il messaggio." type="error" /> : null}
        <Form.Item className="text-left" style={{ marginTop: 10, marginBottom: 10 }}>
            {type === 'contatti' ?
                <Button htmlType="submit" type="primary" size={'large'} ghost className="button-tekno button-tekno-black" loading={state.loading}>Invia <Icon type="arrow-right" /></Button> :
                <Button htmlType="submit" type="primary" size={'large'} ghost className="button-tekno button-tekno-white" loading={state.loading}>Invia <Icon type="arrow-right" /></Button>
            }
        </Form.Item>
    </Form>
}


const FormContatti = Form.create({ name: "form-contatti" })(CreateFormContatti);
export default FormContatti;